import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { Link, useNavigate } from "react-router-dom";
import AppLayout from "../components/AppLayout";
import { deleteCategories, getCategories, updateCategories } from "../logic/categories/action";
import {MdClose, MdDelete, MdEdit} from 'react-icons/md'
import InputComponents from "../components/input";
import { failedCategories } from "../logic/categories/reducer";
import FormikForm from "../components/commonForm";
import { feildsCategories, initialValuesCategories, validationSchemaCategories } from "../fromsUtil/categories.from";
import Header from "../components/header";

const Categories = () => {
  const dispatch = useDispatch();
  const nav = useNavigate();
  const [open, setopen] = useState(false);
  const [data, setdata] = useState({
    business_type:'',
    customer_alias:'',
    staff_alias:'',
    preset_id:0,
  });
  const selector = useSelector((state) => state?.categories);
  useEffect(() => {
    getCategories(dispatch);
  }, []);

  console.log(selector, "categories data");


  const onSubmit = async(values,submitProps)=>{
    // await addCategories(dispatch,values,nav);
    await updateCategories(dispatch,{...values,preset_id:data.preset_id});
    setopen(false);
    submitProps.setSubmitting(true);
    submitProps.resetForm();
  }

  console.log(data,'hi');

  return (
    <AppLayout>
      {
        open &&
      
      <div className={`${open?'flex':'hidden'} fixed top-0 left-0 w-screen h-screen justify-center items-center bg-[#6565656c]`}>
            <div className="flex w-1/2 h-1/2 flex-col items-center gap-4 bg-white p-10 relative">
                <h2>Edit Category</h2>
                {/* <InputComponents isRequired={true} type="text" label="Category Name" name="name" id="name" value={data.name} onChange={(e)=>setdata(prev=>({...prev,[e.target.name]:e.target.value}))}/>
                <InputComponents isRequired={true} type="text" label="Patient Alias" name="patient_alias" id="patient_alias" value={data.patient_alias || data.customer_alias} onChange={(e)=>setdata(prev=>({...prev,[e.target.name]:e.target.value}))}/>
                <InputComponents isRequired={true} type="text" label="Staff Alias" name="staff_alias" id="staff_alias" value={data.staff_alias} onChange={(e)=>setdata(prev=>({...prev,[e.target.name]:e.target.value}))}/> */}
                <FormikForm
                   initialValues={data}
                   fields={feildsCategories}
                   validationSchema={validationSchemaCategories}
                   action={(disabled)=><button disabled={disabled} className='w-full' type='submit'>Add Category</button>}
                   onSubmit={onSubmit}
                   />
                   {
                     selector.error&&<p className="text-red-500">{selector.errorMessage}</p>
                   }
                {/* <button onClick={()=>
                  {
                    if(data.name!=='' && data.customer_alias !== '' && data.staff_alias !== ''){
                      updateCategories(dispatch,{business_type:data.name,customer_alias:data.customer_alias,staff_alias:data.staff_alias,preset_id:data.preset_id});
                      setopen(false)
                    }else{
                      dispatch(failedCategories({message:'Please fill all details.'}));
                    }
                  }
                  }>Edit</button> */}
                <p onClick={()=>setopen(false)} className="absolute top-4 right-10 cursor-pointer"><MdClose/></p>
            </div>
      </div>
    }
      <div className="flex-1 h-full p-4">
       
      <Header/>
        <div className='w-full flex flex-col items-start gap-4'>
        <div className="flex justify-between w-full">
          <h1 className="font-bold text-2xl">Categories</h1>
          <Link to={"/admin/categories/add"}>
            <button className="w-12 h-12 rounded-full">+</button>
          </Link>
        </div>
        <div className="w-full h-[80%] flex flex-col shadow-lg gap-4">
          <div className="py-4 h-auto flex w-full bg-gray-500 text-white font bold">
            <p className="flex-1 text-center">Id</p>
            <p className="flex-1 text-center">Category</p>
            <p className="flex-1 text-center">Staff Alias</p>
            <p className="flex-1 text-center">Patient Alias</p>
            <p className="flex-1 text-center">Action</p>
          </div>
          <div className="flex-1 overflow-y-scroll">
            {
              selector?.data?.map(
                (el,i)=> <div
                    className="py-4 flex w-full border-b-[0.1px] border-gray-500 font bold"
                    key={i}
                  >
                    <p className="flex-1 cursor-pointer text-center text-blue-500 underline">
                      <Link to={`/admin/categories/${el?.preset_id}`}>{el?.preset_id}</Link>
                      </p>
                    <p className="flex-1 cursor-pointer text-center">{el?.business_type}</p>
                    <p className="flex-1 cursor-pointer text-center">{el?.customer_alias}</p>
                    <p className="flex-1 cursor-pointer text-center">{el?.staff_alias}</p>
                    <p className="flex-1 cursor-pointer gap-2 text-center flex justify-center items-center">
                      <MdEdit onClick={()=>{
                        // nav()
                        setdata({
                          business_type:el?.business_type,
                          customer_alias:el?.customer_alias,
                          staff_alias:el?.staff_alias,
                          preset_id:el?.preset_id
                        });
                        setopen(true)
                      }}/>
                      {
                        el.preset_id !== 3 &&
                        <MdDelete color="red"
                        onClick={()=>{
                          const confirmData = window.confirm('Are you sure you want to delete type?');
                          if(confirmData){
                            deleteCategories(dispatch,el?.preset_id);
                          }
                        }}
                        />
                      }
                    </p>
                  </div>
              )

              // JSON.stringify(selector?.data)
              // selector?.data?.map((element,i)=><p key={i}>hi</p>)
              // selector?.data?.map((e, i) => (
              //   <div
              //     className="py-4 flex w-full border-b-[0.1px] border-gray-500 font bold"
              //     key={i}
              //   >
              //     <p className="flex-1 cursor-pointer text-center">
              //       <Link to={"/business/" + e?.business_id}>
              //         {e?.business_id}
              //       </Link>
              //     </p>
              //     <p className="flex-1 text-center capitalize">{e?.name}</p>
              //     {/* <p className='flex-1 text-center capitalize'>{parseInt(moment(e?.expired_plan).format('MM'))+1 }</p> */}
              //     <p className="flex-1 text-center">
              //       {moment(e?.expired_plan).format("DD-MM-YYYY")}
              //     </p>
              //     <p className="flex-1 text-center">
              //       {e?.restrict === 0 ? "No" : "Yes"}
              //     </p>
              //     <p className="flex-1 text-center flex flex-col items-center gap-4">
              //       <button
              //         onClick={() => {
              //           restrictBusiness(
              //             dispatch,
              //             e?.business_id,
              //             e?.restrict === 0 ? 1 : 0
              //           );
              //         }}
              //       >
              //         {e?.restrict === 0 ? "Restrict" : "Unrestrict"}{" "}
              //       </button>
              //     </p>
              //     <p className="flex-1 text-center flex flex-col items-center gap-4">
              //       <div onClick={() => {}}>
              //         {/* <label htmlFor={`date-${e?.business_id}`}>{'Renew'}</label> */}
              //         {/* <input className='' onChange={(ev)=>{renewLocal(e?.business_id,ev?.target?.value)}} id={`date-${e?.business_id}`} name={`date-${e?.business_id}`} placeholder={'Select Date'} type="date" /> */}
              //         {/* <input className='' onChange={(ev)=>console.log(ev.target.value,"hello")} id={`date-${e?.business_id}`} name={`date-${e?.business_id}`} placeholder={'Select Date'} type="date" /> */}
              //         <select
              //           className="border px-2 py-1 rounded-md border-blue-800 text-blue-800"
              //           name={`date-${e?.business_id}`}
              //           id={`date-${e?.business_id}`}
              //           onChange={(e) =>
              //             console.log(
              //               parseInt(e.target.value),
              //               "input type select"
              //             )
              //           }
              //         >
              //           <option value="1">1 Month</option>
              //           <option value="3">3 Months</option>
              //           <option value="6">6 Months</option>
              //           <option value="12">12 Months</option>
              //         </select>
              //       </div>
              //     </p>
              //   </div>
              // ))
            }
          </div>
        </div>
      </div>
      </div>
    </AppLayout>
  );
};

export default Categories;
